import { minWidthQuery, layoutRecalcManager, layoutPhaseMeasure, layoutPhaseApply } from '@theme/theme-global';

class ContentReveal extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    this.container = this.querySelector('[data-container]');
    this.cards = this.querySelectorAll('[data-animate="card"]');
    this.update = this.update.bind(this);
    this.measure = this.measure.bind(this);
    this.rafId = null;
    this.baseScale = 1;
    this.mediaQuery = minWidthQuery(768);
    this.hasDesktopSticky = !!this.querySelector('[data-sticky-background-image-desktop]');
    this.hasMobileSticky = !!this.querySelector('[data-sticky-background-image-mobile]');
    this.isEnabled = false;
  }

  connectedCallback() {
    layoutRecalcManager.register(this.measure, { root: this });
    window.addEventListener('scroll', this.update, { passive: true });
  }

  measure(phase) {
    if (!this.section || !this.container) return;

    if (layoutPhaseMeasure(phase)) {
      const sectionWidth = this.section.offsetWidth;
      const containerWidth = this.container.offsetWidth;
      this.baseScale = Math.min(containerWidth / sectionWidth, 1);
      this.isEnabled = this.mediaQuery.matches ? this.hasDesktopSticky : this.hasMobileSticky;
    }

    if (layoutPhaseApply(phase)) {
      if (!this.isEnabled) {
        this.section.style.setProperty('--scaleValue', '1');
      }
      this.update();
    }
  }

  update() {
    const VIEWPORT_START_RATIO = 0.5; // container at 50% viewport → progress 0
    const VIEWPORT_END_RATIO = 0.2; // container at 20% from top → progress 1, scale 1

    if (!this.section || !this.container) return;
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.rafId = requestAnimationFrame(() => {
      const vh = window.innerHeight;
      const containerTop = this.container.getBoundingClientRect().top;
      const startY = VIEWPORT_START_RATIO * vh;
      const endY = VIEWPORT_END_RATIO * vh;
      const range = startY - endY;
      const progress = range <= 0 ? 1 : Math.min(Math.max(0, (startY - containerTop) / range), 1);

      if (this.isEnabled) {
        const scale = this.baseScale + (1 - this.baseScale) * progress;
        this.section.style.setProperty('--scaleValue', String(scale));
      }

      this.cards.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const speed = parseInt(el.dataset.parallaxSpeed, 10) || 0;
        if (!speed) return;

        const totalDistance = vh + rect.height;
        const travelled = vh - rect.top;

        const cardProgress = travelled / totalDistance;
        const clamped = Math.min(Math.max(cardProgress, 0), 1);

        const intensity = vh * 0.2; // 20vh travel (stronger feel)
        const translateY = -intensity * clamped * (speed / 25);

        el.style.transform = `translate3d(0, ${translateY}px, 0)`;
      });

      this.rafId = null;
    });
  }

  disconnectedCallback() {
    layoutRecalcManager.unregister(this.measure);
    window.removeEventListener('scroll', this.update);
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }
}
if (!customElements.get('content-reveal')) {
  customElements.define('content-reveal', ContentReveal);
}
